import { db } from "@/firebaseConfig";

const typeOrdersCollection = db.collection("type_orders");

const saveTypeOrder = async data => {
  typeOrdersCollection
    .doc()
    .set(data)
    .then(() => {
      console.log("TypeOrder successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const updateTypeOrder = async (id, data) => {
  typeOrdersCollection
    .doc(id)
    .update(data)
    .then(() => {
      console.log("TypeOrder successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const deleteTypeOrder = async id => {
  typeOrdersCollection
    .doc(id)
    .delete()
    .then(() => {
      console.log("TypeOrder successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const getTypeOrderById = async id => {
  return typeOrdersCollection
    .doc(id)
    .get()
    .then(doc => {
      return doc.exists ? doc.data() : null;
    })
    .catch(error => {
      throw error;
    });
};

export {
  typeOrdersCollection,
  saveTypeOrder,
  updateTypeOrder,
  deleteTypeOrder,
  getTypeOrderById
};
